<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.54 12.2613C22.54 11.4459 22.4668 10.6618 22.3309 9.90906H11.5V14.3575H17.6891C17.4225 15.795 16.6123 17.0129 15.3943 17.8284V20.7138H19.1109C21.2855 18.7118 22.54 15.7636 22.54 12.2613Z"
      fill="#4285F4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 23.4998C14.605 23.4998 17.2081 22.47 19.1109 20.7137L15.3943 17.8282C14.3645 18.5182 13.0472 18.9259 11.5 18.9259C8.50474 18.9259 5.96951 16.903 5.06519 14.1848H1.22314V17.1644C3.11542 20.9228 7.00451 23.4998 11.5 23.4998Z"
      fill="#34A853"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.06523 14.1851C4.83523 13.4951 4.70455 12.7581 4.70455 12.0001C4.70455 11.2422 4.83523 10.5051 5.06523 9.81512V6.83557H1.22318C0.444318 8.38807 0 10.1444 0 12.0001C0 13.8558 0.444318 15.6122 1.22318 17.1647L5.06523 14.1851Z"
      fill="#FBBC05"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 5.07386C13.1884 5.07386 14.7043 5.65409 15.8961 6.79364L19.1945 3.49523C17.2029 1.63955 14.5997 0.5 11.5 0.5C7.00451 0.5 3.11542 3.07705 1.22314 6.83545L5.06519 9.815C5.96951 7.09682 8.50474 5.07386 11.5 5.07386Z"
      fill="#EA4335"
    />
  </svg>
</template>

<script>
export default {
  name: 'Google'
};
</script>
